import React, { useContext } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import { defineMessage, useIntl } from "react-intl"
import { RadioGroupStep } from "#/components/carrot-card-cost-share/steps/variants/RadioGroupStep"
import { CarrotCardCostSharePreAuthContext } from "../../state/CarrotCardCostSharePreAuthContext"
import { useConvertTranslatedLabel } from "#/services/common-forms/useConvertTranslatedLabel"
import { FormSelectOption } from "@carrotfertility/carotene-core-x"

const receiveCareOptions = [
  { label: defineMessage({ defaultMessage: "Fertility clinic" }), value: "FERTILITY_CLINIC" },
  { label: defineMessage({ defaultMessage: "OB/GYN" }), value: "OBGYN" }
]

export function ReceiveCareEligibleProviderStep(): JSX.Element {
  const intl = useIntl()
  const { send } = useStateMachine()
  const {
    dispatchFormState,
    formState: { receiveCareFromEligibleProvider }
  } = useContext(CarrotCardCostSharePreAuthContext)

  const formattedOptions = useConvertTranslatedLabel(receiveCareOptions) as FormSelectOption[]

  function onSubmit(formValues: { [key: string]: string }): void {
    dispatchFormState({
      type: "UPDATE_FIELD",
      field: "receiveCareFromEligibleProvider",
      value: formValues.receiveCareFromEligibleProvider
    })
    if (formValues.receiveCareFromEligibleProvider === "FERTILITY_CLINIC") {
      send("FERTILITY_CLINIC")
    } else {
      send("OBGYN")
    }
  }

  return (
    <RadioGroupStep
      title={intl.formatMessage({
        defaultMessage: "Will you receive care from an eligible fertility clinic or an eligible OB/GYN?"
      })}
      description={intl.formatMessage({
        defaultMessage: "We need this information to process your expense accurately."
      })}
      name="receiveCareFromEligibleProvider"
      options={formattedOptions}
      onSubmit={onSubmit}
      defaultValue={receiveCareFromEligibleProvider}
    />
  )
}
